type AdminTag = {
  id: number;
};

type CanCreateRiskArgs = {
  isAdmin: boolean | null | undefined;
  currentUserTags?: {
    adminTags?: AdminTag[];
  };
};

export const canCreateRisk = ({
  isAdmin,
  currentUserTags,
}: CanCreateRiskArgs) => {
  return Boolean(isAdmin) || Boolean(currentUserTags?.adminTags?.length);
};